import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import { ReactComponent as ArrowDownIcon } from '../../../../resource/arrows/arrow-down.svg';
import styles from './FilterButton.module.scss';

const FilterButton = ({
  text,
  selected = false,
  opened = false,
  className,
  withArrow = true,
  ...props
}) => {
  return (
    <Button
      {...props}
      className={cn(styles.root, className, {
        [styles.opened]: opened,
        [styles.selected]: selected,
      })}
    >
      {text}
      {withArrow && <ArrowDownIcon className={styles.icon} />}
    </Button>
  );
};

export default FilterButton;
